reqData